import React, { useRef } from 'react';
import '../../../../Assets/Css/EmpProjectTask.scss';
import Table from '../../../../Components/Table';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from 'react';
import { customStyle } from '../../../../Components/Style';
import { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import qs from 'query-string';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import CustomCalendar from '../../../../Components/CustomCalendar';
import { getTasks, getTaskStatus, updateTask } from '../../../../Services/Task/action';
import { deleteRecord } from '../../../../Services/Delete/action';
import { getTime } from '../../../../Lib/utils';
import moment from 'moment';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../../Assets/ModulesLiist';
import FeaturesList from '../../../../Assets/FeaturesList';
import { exportData } from '../../../../Lib/exportData';
import useTimerStore from '../../../../Lib/timerStore';

const EmpProjectTask = (props) => {
  const [checked, setChecked] = useState(false);
  const [params, setParams] = useState({});
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [inData, setInData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const fileInputRef = useRef(null);
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, employeeId } = useParams();

  const header = [
    { field: "checkbox" },
    { field: 'Timer' },
    { field: 'Code' },
    { field: 'Time' },
    { field: 'Task' },
    { field: 'Project' },
    { field: 'Start Date' },
    { field: 'Due Date' },
    { field: 'Hours Logged' },
    { field: 'Assigned To' },
    { field: 'Status' },
    { field: 'Action' },
  ];

  let footer = true;
  let count = inData?.length;

  const canView = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.View,
  });

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.Delete,
  });

  const canEdit = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.Update,
  });

  useEffect(() => {
    fetchData();
  }, [location.search]);

  const fetchData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props?.getTasks();
      await props?.getTaskStatus();

    } catch (error) {
      console.error('Error fetching tasks in employee project view:', error);
    }
  };

  const isTimerRunning = (assignedUserIds, currentUserRole, allTasks) => {

    const allRunningTimers = allTasks
      ?.flatMap(task => task?.taskTimerMap || [])
      ?.filter(timer => timer?.state !== "stopped");

    if (currentUserRole === "hr_senior") {
      return allRunningTimers.some(t => assignedUserIds.includes(t?.employee_id));
    }

    return allRunningTimers.some(t => assignedUserIds.includes(t?.employee_id) && t?.state != "stopped");
  };

  useEffect(() => {
    const updateContent = async () => {
      const content = await Promise.all(props?.task?.filter((t) => t?.project_id == projectId)?.map((item) => {
        const taskTimers = item?.taskTimerMap?.[0];
        const allTimers = item?.taskTimerMap;

        allTimers?.forEach((timer) => {
          // if (timer?.state !== "stopped") {

          const key = `${timer.employee_id}_${timer.task_id}`;
          useTimerStore.setState(state => ({
            timers: {
              ...state.timers,
              [key]: {
                ...state.timers[key],
                taskId: timer.task_id,
                startTime: timer.start_time,
                status: timer?.state,
                actionHistory:
                  typeof timer.action_history === "string"
                    ? JSON.parse(timer.action_history)
                    : timer.action_history || [],
              },
            },
          }));
          // }
        })
        const actionHistory = typeof taskTimers?.action_history === "string"
          ? JSON.parse(taskTimers?.action_history)
          : taskTimers?.action_history || [];
        const { time, hoursLogged } = getTime(
          taskTimers?.start_time,
          taskTimers?.stop_time,
          actionHistory,
        )
        let totalElapsedTime = 0;
        allTimers?.forEach((timer) => {
          if (timer?.duration) {
            const [hh, mm, ss] = timer?.duration?.split(/[hms\s]+/).filter(Boolean).map(Number);
            totalElapsedTime += hh * 3600 + mm * 60 + ss;
          }
        });

        const totalH = Math.floor(totalElapsedTime / 3600);
        const totalM = Math.floor((totalElapsedTime % 3600) / 60);
        const totalS = totalElapsedTime % 60;
        const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

        return {
          checkbox: {
            value: item?.id,
            value2: item?.taskTimerMap?.find(timer => timer?.state != "stopped")?.id,
            type: "checkbox",
          },
          Code: {
            value: `CD_${item?.id}`,
            type: 'emptext',
          },
          Timer: (() => {
            if (item?.status != "Approved" && item?.status != "Completed") {
              if (props?.user?.role?.name !== "hr_senior") {
                return {
                  value: item?.taskUserMap?.some(user => user.user_id == props?.user?.id) ?
                    allTimers?.find((timer) => timer?.employee_id === props?.user?.id && timer?.state != "stopped")
                      ? allTimers?.find((timer) => timer?.employee_id === props?.user?.id && timer?.state != "stopped")?.state
                      : '' : '--',
                  type: 'taskstartstop',
                };
              }

              const assignedUsers = item?.taskUserMap || [];
              if (assignedUsers?.length > 1) {
                return {
                  value: '--',
                  type: 'taskstartstop'
                }

              }
              const latestTimer = allTimers?.find(timer => timer?.state != "stopped");
              return {
                value: latestTimer?.state || '',
                type: 'taskstartstop',
              };
            } else {
              return {
                value: '--',
                type: 'taskstartstop'
              }
            }
          })(),

          Time: (() => {
            let totalElapsed = 0;
            let isRunning = false;

            const activeTimers = allTimers?.filter(
              timer => timer?.state !== "stopped" && timer?.task_id === item?.id
            ) || [];
            const assignedUsers = item?.taskUserMap || [];

            if (assignedUsers?.length > 1) {
              if (activeTimers?.length > 1) {
                return {
                  value: "2 Active Timers",
                  type: 'emptasktimer'
                }
              }

              else if (activeTimers?.length == 1) {
                return {
                  value: "1 Active Timer",
                  type: 'emptasktimer'
                }
              }
            }

            allTimers?.forEach(timer => {
              if (timer?.state !== "stopped") {
                const history = typeof timer?.action_history === 'string'
                  ? JSON.parse(timer?.action_history)
                  : timer?.action_history || [];

                for (let i = 0; i < history?.length; i++) {
                  const action = history[i];
                  const next = history[i + 1];

                  if ((action?.action === 'start' || action?.action === 'resume')) {
                    const start = new Date(action.time).getTime();

                    if (next && (next?.action === 'pause' || next?.action === 'stop')) {
                      const stop = new Date(next?.time).getTime();
                      isRunning = true;
                      totalElapsed += Math.floor((stop - start) / 1000);
                    } else {
                      isRunning = true;
                      totalElapsed += Math.floor((Date.now() - start) / 1000);
                    }
                  }
                }
              }
            });

            const h = String(Math.floor(totalElapsed / 3600)).padStart(2, '0');
            const m = String(Math.floor((totalElapsed % 3600) / 60)).padStart(2, '0');
            const s = String(totalElapsed % 60).padStart(2, '0');
            const formattedTime = (!isRunning && totalElapsed == 0) ? '--' : `${h}:${m}:${s}`;
            const type = (!isRunning && totalElapsed == 0) ? 'emptext' : 'emptasktimer';
            return {
              value: formattedTime,
              type: type
            };
          })(),
          Task: {
            value: item?.title,
            type: 'emptext',
          },
          Project: {
            value: item?.project?.name || '--',
            type: 'emptext',
          },
          'Start Date': {
            value: item?.start_date?.split(" ")[0],
            type: 'empdate',
          },
          'Due Date': {
            value: item?.due_date?.split(" ")[0] || '--',
            type: 'empdate',
          },
          'Hours Logged': {
            value: totalHoursLogged === "0h 0m 0s" ? '0s' : totalHoursLogged,
            type: 'emptext',
          },
          'Assigned To': {
            value: item?.taskUserMap?.map(user => ({
              name: user?.userTaskMap?.name,
              src: user?.userTaskMap?.profile_pic?.data ? `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.userTaskMap?.profile_pic?.data)))}` : '',
              id: user?.userTaskMap?.id,
              isEmployeeTaskPage: false
            })),
            type: "share holder",
          },
          Status: {
            value: item?.status,
            type: 'status_option',
          },
          Action: {
            value: location?.pathname == `/employees/view/${employeeId}/project/view/${projectId}/task` ? `/employees/view/${employeeId}/project/view/${projectId}/task/edit` : `/project/employeeproject/view/${projectId}/task/edit`,
            value2: location?.pathname == `/employees/view/${employeeId}/project/view/${projectId}/task` ? `/employees/view/${employeeId}/project/view/${projectId}/task/view/${item?.id}` : `/project/employeeproject/view/${projectId}/task/view/${item?.id}`,
            value3: item?.id,
            showIsEdit: canEdit && (props?.user?.role?.name == "hr_senior" ? true : item?.taskUserMap?.some(item => item?.user_id == props?.user?.id)),
            showIsDelete: canDelete && (props?.user?.role?.name == "hr_senior" ? true : item?.taskUserMap?.some(item => item?.user_id == props?.user?.id)),
            type: 'action',
          },
          allData: {
            ...item,
            taskTimers: taskTimers,
            totalHoursLogged: totalHoursLogged,
            time: time
          },
          user: {
            ...props?.user
          },
          timerIsRunning: {
            value: isTimerRunning(
              item?.taskUserMap?.map(user => user?.userTaskMap?.id) || [],
              props?.user?.role?.name,
              props?.task
            )
          }
        };
      }));
      setInData(content);
    };
    updateContent();
  }, [props]);

  const handleClose = () => {
    setShowModal(false);
    setFileName('');
    setSelectedFile(null);
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  const handleChange = (event) => {
    const { type, checked, id, ids } = event;

    if (type === "select-all") {
      setTotalSelectedIds(checked ? [...ids] : []);
    } else if (type === "select-one") {
      if (checked) {
        setTotalSelectedIds(prev => [...prev, id]);
      } else {
        setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
      }
    }
  };

  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      if (type === 'delete') {
        setDeleteLoading(true);
        await props.deletePurchaseInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === 'export') {
        setExportLoading(true);
        handleXlsxDownload(ids);
        toast.success('Exported Successfully');
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      setDeleteLoading(false);
    }
  };

  const handleXlsxDownload = (Ids) => {
    const excludedFields = ['checkbox', 'Action', 'Timer', 'Time'];
    const columns = header
      .filter(col => !excludedFields.includes(col.field))
      .map(col => ({
        label: col.field,
        key: col.field
      }));

    const selectedData = inData
      .filter(item => Ids.includes(item.allData?.id))
      .map(row => {
        const newRow = {};

        columns.forEach(({ label, key }) => {
          const cell = row[key];

          if (!cell) {
            newRow[label] = '';
          } else if (key === 'Assigned To' && Array.isArray(cell.value)) {
            newRow[label] = cell.value.map(person => person.name).join(', ');
          } else if (key === 'Employee' && Array.isArray(cell.value)) {
            newRow[label] = cell.value.map(person => person.name).join(', ');
          } else if (Array.isArray(cell.value)) {
            newRow[label] = cell.value.join(', ');
          } else {
            newRow[label] = cell.value ?? '';
          }
        });

        return newRow;
      });

    exportData({
      data: selectedData,
      columns,
      fileName: 'Project_Task_Report',
      format: 'xlsx',
    });
    setExportLoading(false)
    setTotalSelectedIds([])
  };

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  const handleAddClick = () => {
    location?.pathname?.includes(`/project/employeeproject/view/${projectId}/task`) ? navigate(`/project/employeeproject/view/${projectId}/task/add`) : navigate(`/employees/view/${employeeId}/project/view/${projectId}/task/add`)
  };

  const initialState = {
    date: '',
    projectStatus: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
  };

  const Status = props?.taskStatus?.map((item) => {
    return { value: item?.name, label: item?.name, color: item?.color_code, taskStatus: item?.taskStatus, createdAt: item?.createdAt }
  })
  // const Status = [
  //   { value: 'Hide Completed Task', label: 'Hide Completed Task' },
  //   { value: 'All', label: 'All' },
  //   { value: 'Incomplete', label: 'Incomplete' },
  //   { value: 'To Do', label: 'To Do' },
  //   { value: 'Doing', label: 'Doing' },
  //   { value: 'Completed', label: 'Completed' },
  // ];

  const [clientData, setClientData] = useState(initialState);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState({ value: 'Hide Completed Task', label: 'Hide Completed Task' });
  const [dateStatus, setDateStatus] = useState(false);
  const [isMytaskList, setIsMyTaskList] = useState(false);
  const [filteredStartDate, setFilteredStartDate] = useState(null);
  const [filteredEndDate, setFilteredEndDate] = useState(null);


  const applyFilters = ({ status, search, startDate, endDate }) => {
    setFilteredStartDate(filteredStartDate || startDate);
    setFilteredEndDate(filteredEndDate || endDate);
    const filtered = inData?.filter((task) => {
      let matchesStatus = true;
      let matchesSearch = true;
      let matchesDate = true;
      const taskTitle = task?.Task?.value?.toLowerCase() || '';

      if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
        setDateStatus(true);

        const itemStartDate = moment(task?.["Start Date"]?.value).startOf('day');
        const itemDueDate = task?.["Due Date"]?.value
          ? moment(task?.["Due Date"]?.value).startOf('day')
          : itemStartDate;

        const filterStart = moment(filteredStartDate || startDate).startOf('day');
        const filterEnd = moment(filteredEndDate || endDate).endOf('day');

        matchesDate =
          itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
          itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
      }

      if (status && status?.value !== "All") {
        if (status?.value == "Hide Completed Task") {
          matchesStatus = task?.Status?.value?.toLowerCase() !== "completed";
        } else {
          matchesStatus = task?.Status?.value?.toLowerCase() == status?.value?.toLowerCase();
        }
      }

      if (search) {
        matchesSearch = taskTitle.includes(search.toLowerCase());
      }
      return matchesStatus && matchesSearch && matchesDate;
    });
    setFilteredData(filtered);
  };

  useEffect(() => {
    if (inData?.length > 0 && selectedStatus) {
      applyFilters({ status: selectedStatus, search: searchTerm });
    }
  }, [inData]);

  const handleSelectStatusChange = (val) => {
    setSelectedStatus(val);
    setClientData((prevVal) => ({
      ...prevVal,
      projectStatus: val,
    }));
    applyFilters({ status: val, search: searchTerm });
  };

  const searchFiled = (e) => {
    const { name, value } = e.target;
    setSearchTerm(value);
    setClientData((preVal) => ({
      ...preVal,
      [name]: value,
    }));
    applyFilters({ status: selectedStatus, search: value });
  };

  const handleFetchUserTasks = () => {
    setIsMyTaskList(true);
    const filtered = inData?.filter((item) => item?.["Assigned To"]?.value?.some((user) => user?.id == props?.user?.id))
    setFilteredData(filtered);
  }

  const handleClear = () => {
    setClientData({
      projectStatus: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
      searchTerm: "",
      employeename: ""
    });
    setSearchTerm("");
    setSelectedStatus({ value: 'Hide Completed Task', label: 'Hide Completed Task' });
    setDateStatus(false);
    setIsMyTaskList(false);
    setFilteredData([]);
    setFilteredStartDate(null);
    setFilteredEndDate(null);
    setTimeout(() => {
      applyFilters({ status: { value: 'Hide Completed Task', label: 'Hide Completed Task' }, search: "" });
    }, 0);
  }

  const shouldShowClearButton = () => {
    const hasSearchTerm = searchTerm;
    const hasDateFilter = dateStatus;
    const hasMyTaskFilter = isMytaskList;
    const hasNonDefaultStatus = selectedStatus && selectedStatus.value !== 'Hide Completed Task';

    return hasSearchTerm || hasDateFilter || hasMyTaskFilter || hasNonDefaultStatus;
  };

  return (
    <div className="empProjectTask-main">
      <div className="row">
        <div className="col-lg-4">
          <div className="input-group">
            <h6 className="label">Duration</h6>
            <CustomCalendar
              inData={inData}
              setFilteredData={setFilteredData}
              selectedStatus={selectedStatus}
              searchTerm={searchTerm}
              applyFilters={(params) => { applyFilters(params) }}
              startDate={filteredStartDate}
              endDate={filteredEndDate}
              setStartDate={setFilteredStartDate}
              setEndDate={setFilteredEndDate}
            />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="input-group">
            <h6 className="label">Status</h6>
            <Select
              options={Status?.slice()?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))}
              styles={{
                ...customStyle,
                menu: (provided) => ({
                  ...provided,
                  zIndex: 2,
                }),
              }}
              value={clientData.projectStatus}
              placeholder="---"
              onChange={(val) => handleSelectStatusChange(val)}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="input-group">
            <h6 className="label">Search</h6>
            <input
              type="text"
              className="input-css"
              name="employeename"
              placeholder="Search Name"
              value={clientData?.employeename || ""}
              onChange={searchFiled}
            />
          </div>
        </div>
      </div>

      <div className="gap-4 emptask-export-btn">
        <div>
          <RoleWiseFeatureWrapper
            modules={props?.modules}
            features={props?.features}
            user={props?.user}
            ModuleName={ModulesList.Task}
            Featur_Name={FeaturesList.Create}>

            <button
              className="custom-emptask-btn"
              disabled={props.loading}
              onClick={handleAddClick}
            >
              {props.loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
              ) : (
                'Add Task'
              )}
            </button>
          </RoleWiseFeatureWrapper>

          <button className="custom-emptask-btn" disabled={props.loading} onClick={handleFetchUserTasks}>
            {props.loading ? (
              <Spinner as="span" animation="border" role="status" aria-hidden="true" />
            ) : (
              'My Task'
            )}
          </button>

          <button
            className="export-btn"
            id="exportBtn"
            disabled={!checked || exportLoading}
            onClick={(e) => {
              e.preventDefault();
              handleClick(totalSelectedIds, 'export');
            }}
          >
            {exportLoading ? (
              <Spinner
                as="span"
                animation="border"
                className="custom-spinner"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Export'
            )}
          </button>

          {/* {(selectedStatus.value !== 'Hide Completed Task' || searchTerm || filteredData?.length > 0 || dateStatus || isMytaskList) && ( */}
          {shouldShowClearButton() && (
            <button
              className="custom-emptask-btn"
              disabled={props.loading}
              onClick={handleClear}
            >
              {props.loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
              ) : (
                'Clear'
              )}
            </button>
          )}
        </div>
      </div>

      <div className="invoice-table-part">
        <Table
          header={header}
          data={(searchTerm || selectedStatus || dateStatus || isMytaskList) ? filteredData : inData}
          footer={footer}
          count={count}
          records={count}
          defaultParams={params}
          totalSelectedIds={totalSelectedIds}
          handleChange={handleChange}
          showIsView={canView}
          updateTask={props?.updateTask}
          deleteRecord={props?.deleteRecord}
          user={props?.user}
          TaskStatus={Status}

        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.taskReducer.loading,
    task: state.taskReducer.task,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
    addTask: state.taskReducer.addTask,
    taskStatus: state.taskReducer.taskStatus

  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getTasks: () => {
      dispatch(getTasks())
    },
    updateTask: (id, data, showToast) => {
      dispatch(updateTask(id, data, showToast))
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue))
      await dispatch(getTasks());
    },
    getTaskStatus: () => {
      dispatch(getTaskStatus())
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectTask);

